import axios from 'config/axios';
import Auth from './Auth';

export default class Api {
    static async loadOption(optionTitle) {
        await Auth.checkCurrentAuthToken();
        return await axios
            .get(`/api_v2/options/${optionTitle}`)
            .then((res) => res.data.option)
            .catch((error) => {
                console.log(`Cannot check current auth token: ${error}`);
            });
    }

    static async getNotifications(teacherId, limit, offset) {
        await Auth.checkCurrentAuthToken();
        const apiUrl = `/api_v2/teachers/${teacherId}/notifications?limit=${limit}&offset=${offset}`;

        return axios.get(apiUrl).then((res) => res.data);
    }

    static async readNotification(teacherId, notificationId, notifiedAt) {
        await Auth.checkCurrentAuthToken();
        await axios.put(`/api_v2/teachers/notification/${teacherId}`, {
            notificationId,
            notifiedAt,
        });
    }

    static async getVersion() {
        await Auth.checkCurrentAuthToken();
        return await Api.loadOption('version');
    }

    static async getRelease(teacherId = null) {
        await Auth.checkCurrentAuthToken();
        return await axios.get(`/api_v2/teachers/releases/${teacherId ? teacherId : ''}`).then((res) => res.data);
    }

    static async releaseViewed(teacherId, version) {
        await Auth.checkCurrentAuthToken();
        return await axios.put(`/api_v2/teachers/releases/${teacherId}/${version}`);
    }

    static async badgesAwardable() {
        await Auth.checkCurrentAuthToken();
        return await axios.get('/api_v2/badges?awardable=1').then((res) => res.data);
    }

    static async loadTrialSettings() {
        await Auth.checkCurrentAuthToken();
        const trialSettings = await Api.loadOption('trial-settings');
        try {
            if (trialSettings) {
                return JSON.parse(trialSettings);
            }
        } catch (err) {
            console.log('Error parsing trial data - ', err.message || -'No error detail!');
            return {};
        }
    }

    //load states related to trial for a teacher
    static async trialState(teacherId) {
        await Auth.checkCurrentAuthToken();
        return await axios
            .get(`/api_v2/teachers/trialState/${teacherId}`)
            .then((resp) => resp.data)
            .catch((err) => {
                console.log('error loading teacher trial state: ', err.message || 'No error info.');
                return null;
            });
    }

    static async updateTrialState(teacherId, updateData) {
        await Auth.checkCurrentAuthToken();
        return await axios
            .post(`/api_v2/teachers/trialState/${teacherId}`, updateData)
            .then((resp) => resp.data)
            .catch((err) => {
                console.log('error updating teacher trial state: ', err.message || 'No error info.');
                return null;
            });
    }

    static async resendTeacherVerificationEmail(teacherId) {
        await Auth.checkCurrentAuthToken();
        return await axios
            .get(`/api/teachers/resendVerifyEmail/${teacherId}`)
            .then((resp) => resp.data)
            .catch((err) => console.log('Error: resending verify email. ', err.message || 'No error info.'));
        // return false;
    }

    static async updateUnverifiedTeacherEmail({ teacherId, email }) {
        await Auth.checkCurrentAuthToken();
        return await axios.put(`/api/teachers/updateEmail/${teacherId}`, { email });
    }

    static async getSchoolsList() {
        await Auth.checkCurrentAuthToken();
        return await axios
            .get('/api/schools/list')
            .then((resp) => resp.data)
            .catch((err) => console.log('Error: resending verify email. ', err.message || 'No error info.'));
    }

    static async setAsBestAttempt({ classId, studentId, unitId, lessonId, attemptId }) {
        await Auth.checkCurrentAuthToken();
        return await axios
            .put('/api_v2/dashboard/setBestAttempt/', {
                classId,
                studentId,
                unitId,
                lessonId,
                attemptId,
            })
            .then((resp) => {
                if ('success' in resp.data && resp.data.success === true) {
                    return true;
                } else {
                    return false;
                }
            })
            .catch((err) => {
                console.error('Error: failed to set as best answer ', err.message || '');
                return false;
            });
    }
}
